import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { getVisibleFieldsList } from "../../apis/collection"
import { addErrorNotification } from "../notifications/actions"
import { ICollectionState, SliceDataParams } from "."

// TODO: Slice needed changes to work with multiple collection on the page
// https://tracker.tenforce.com/workspace/823/3135l/1479792
export const collectionSlice = createSlice({
    name: "collection",

    initialState: {
        isQueryProcessing: false,
        visibleFields: [],
        visibleFieldsIds: [],
        selectableFieldDefinitions: [],
    } as ICollectionState,

    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(fetchVisibleFields.pending, (state) => {
                state.isQueryProcessing = true
            })
            .addCase(fetchVisibleFields.fulfilled, (state, action) => {
                state.visibleFields = action.payload?.fields || []
                state.visibleFieldsIds =
                    action.payload?.fields.map((field) => field.id) || []
                state.isQueryProcessing = false
            })
    },
})

export default collectionSlice.reducer

export const fetchVisibleFields = createAsyncThunk(
    "itemCollection/fetchVisibleFields",
    async (data: SliceDataParams, { dispatch }) => {
        try {
            const selectedData = await getVisibleFieldsList(
                data.itemId,
                data.fieldId,
                data.odataType,
            )
            return selectedData
        } catch (error) {
            dispatch(addErrorNotification(error.message))
        }
    },
)
